// import axios from "axios";
import AxiosService from "./axiosServices";
const axiosService = new AxiosService();
class Service {
  Login = async (body) => {
    // let ipAddress = "";
    // try {
    //   const response = await axios.get(IPIFY_API_URL);
    //   ipAddress = response?.data?.ip;
    //   // Now you can send this IP address to your backend
    //   // Make sure to include it in your login request payload
    //   // Example:
    //   // axios.post('/login', { username: 'user', password: 'pass', ipAddress: ipAddress });
    // } catch (error) {
    //   console.error("Error fetching IP address:", error);
    // }

    // // Check if body contains another object
    // if (
    //   typeof body === "object" &&
    //   body !== null &&
    //   typeof body?.body === "object" &&
    //   body?.body !== null
    // ) {
    //   // Add ipAddress to the child body object
    //   body.body.ipAddress = ipAddress;
    // } else {
    //   console.error(
    //     "Invalid body format. Expected object with 'body' property."
    //   );
    // }

    return axiosService.Post(`api/login/`, body);
  };

  userLogout = () => {
    return axiosService.Get(`api/logout/`);
  };
  allUserLogout = (data) => {
    return axiosService.Post(`api/logout-of-all-devices/`, data);
  };

  forgotPasswordLink = (userName, passwordResetLink) => {
    const data = {
      body: { username: userName, password_reset_link: passwordResetLink },
    };
    return axiosService.Post(`api/send-reset-password-link/`, data);
  };

  forgotPassword = (userName, newPassword, token) => {
    const data = {
      body: { password: newPassword, hash_key: token },
    };
    return axiosService.Post(`api/update-password/`, data);
  };

  saveUserSignature(filePath) {
    const data = {
      body: {
        signature_b64: filePath,
      },
    };
    return axiosService.Post(`api/upload-e-signature/`, data);
  }
  getUserSignature() {
    return axiosService.Get(`api/get-uploaded-e-signature/`);
  }

  submitOtp(otp) {
    const data = {
      body: {
        otp: otp,
      },
    };
    return axiosService.Post(`api/verify-otp/`, data);
  }
  resendOtp(userName) {
    const data = {
      body: { username: userName },
    };
    return axiosService.Post(`api/resend-otp/`, data);
  }
  sendIP(ip, id) {
    const data = {
      body: { user_ip: ip, user_id: id },
    };
    return axiosService.Post(`api/store-user-ip/`, data);
  }
  checkLinkStatus = (hash_key) => {
    const params = {
      hash_key: hash_key,
    };
    return axiosService.Get(`api/check-password-reset-url/`, {
      params: params,
    });
  };

  checkVlmStatus = () => {
    return axiosService.Get(`api/get-vlm-status/`);
  };

}

export default Service;
